import { render, staticRenderFns } from "./warehousearchivestable.vue?vue&type=template&id=7a3d6c08&scoped=true&"
import script from "./warehousearchivestable.vue?vue&type=script&lang=js&"
export * from "./warehousearchivestable.vue?vue&type=script&lang=js&"
import style0 from "./warehousearchivestable.vue?vue&type=style&index=0&id=7a3d6c08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3d6c08",
  null
  
)

export default component.exports